import type { NavItemType } from 'types/menu'
import pages from './pages'

const menuItems: { items: NavItemType[] } = {
  items: [pages],
}

export default menuItems
